import { reactive, toRefs } from "vue";

export const useRequestState = () => {
  const state = reactive({
    isLoading: false,
    isFailed: false,
    isSuccess: false,
  });

  const setLoadingState = () => {
    state.isLoading = true;
    state.isFailed = false;
    state.isSuccess = false;
  };

  const setSuccessState = () => {
    state.isLoading = false;
    state.isFailed = false;
    state.isSuccess = true;
  };

  const setFailedState = () => {
    state.isLoading = false;
    state.isFailed = true;
    state.isSuccess = false;
  };

  return {
    ...toRefs(state),
    setLoadingState,
    setSuccessState,
    setFailedState,
  };
};
